import { observer } from 'mobx-react-lite';
import FloatTypeField from '../FieldByType/floatTypeField';
import DateTypeField from '../FieldByType/dateTypeField';
import PeriodTypeField from '../FieldByType/periodTypeField';
import TimeTypeField from '../FieldByType/timeTypeField';
import RangeTypeField from '../FieldByType/rangeTypeField';
import ProgressTypeFields from '../FieldByType/progressTypeFields';
import TextStringTypeField from '../FieldByType/textStringTypeField';
import SelectTypeField from '../FieldByType/selectTypeField';
import SelectCheckTypeField from '../FieldByType/selectCheckTypeField';
import EmailTypeField from '../FieldByType/emailTypeField';
import PhoneTypeField from '../FieldByType/phoneTypeField';
import UrlTypeField from '../FieldByType/urlTypeField';
import SwitchVariantTypeField from '../FieldByType/switchVariantTypeField';
import BaseTypeField from '../FieldByType/baseTypeField';
import ColorTypeField from '../FieldByType/colorTypeField';
import IconTypeField from '../FieldByType/iconTypeField';
import SwitchTypeField from '../FieldByType/switchTypeField';
import BarcodeTypeField from '../FieldByType/barcodeTypeField';
import YesNoTypeField from '../FieldByType/yesNoTypeField';
import ImageTypeField from '../FieldByType/imageTypeField';
import FileTypeField from '../FieldByType/fileTypeField';
import CalcTypeField from '../FieldByType/calcTypeField';
import FinanceTypeField from '../FieldByType/financeTypeField';
import LocationTypeField from '../FieldByType/locationTypeField';
import IntegerTypeField from '../FieldByType/integerTypeField';
import PropTypes from 'prop-types';

const FormFieldRenderer = observer(({ type, ...commonProps }) => {
  switch (type) {
    case 'integer':
      return <IntegerTypeField {...commonProps} />;
    case 'float':
      return <FloatTypeField {...commonProps} />;
    case 'date':
      return <DateTypeField {...commonProps} />;
    case 'period':
      return <PeriodTypeField {...commonProps} />;
    case 'time':
      return <TimeTypeField {...commonProps} />;
    case 'range':
      return <RangeTypeField {...commonProps} />;
    case 'progress':
      return <ProgressTypeFields {...commonProps} />;
    case 'string':
    case 'text':
      return <TextStringTypeField {...commonProps} />;
    case 'select':
      return <SelectTypeField {...commonProps} />;
    case 'select_check':
      return <SelectCheckTypeField {...commonProps} />;
    case 'email':
      return <EmailTypeField {...commonProps} />;
    case 'phone':
      return <PhoneTypeField {...commonProps} />;
    case 'url':
      return <UrlTypeField {...commonProps} />;
    case 'switch_variants':
      return <SwitchVariantTypeField {...commonProps} />;
    case 'base':
      return <BaseTypeField {...commonProps} />;
    case 'color':
      return <ColorTypeField {...commonProps} />;
    case 'icon':
      return <IconTypeField {...commonProps} />;
    case 'switch':
      return <SwitchTypeField {...commonProps} />;
    case 'barcode':
      return <BarcodeTypeField {...commonProps} />;
    case 'yes_no':
      return <YesNoTypeField {...commonProps} />;
    case 'image':
      return <ImageTypeField {...commonProps} />;
    case 'file':
      return <FileTypeField {...commonProps} />;
    case 'calc':
      return <CalcTypeField {...commonProps} />;
    case 'finance':
      return <FinanceTypeField {...commonProps} />;
    case 'location':
      return <LocationTypeField {...commonProps} />;
    default:
      return null;
  }
});

FormFieldRenderer.propTypes = {
  type: PropTypes.string.isRequired,
};

export default FormFieldRenderer;
